import { customElement, query, state } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement } from 'lit'

import { STORE_LOCATOR_STORE, StoreLocatorStore } from 'components/discovery/store-locator/store-locator-store.js'
import { InternalStore } from 'components/discovery/store-locator/typing/store-locator.js'
import {
  COORDINATE_TYPE_ZOOM,
  CSMapCoordinates,
  CSMapZoomConfiguration
} from 'components/discovery/store-locator/typing/internal.js'

import { style } from './store-map.style.js'
import {
  STORE_MAP_CONFIGURATION_STORE,
  StoreMapConfigurationStore
} from 'components/discovery/store-locator/components/store-map/store-map-config-store.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { createEffect } from '@cloudsuite/mosaic-shared/scripts/signals.js'


@customElement('csc-store-map')
export class CSCStoreMap extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @inject(STORE_LOCATOR_STORE)
  storeLocatorStore!: StoreLocatorStore

  @inject(STORE_MAP_CONFIGURATION_STORE)
  mapConfigStore!: StoreMapConfigurationStore

  @state()
  stores: InternalStore[] = []

  @state()
  coordinates: CSMapCoordinates | null = null

  @state()
  config: CSMapZoomConfiguration = COORDINATE_TYPE_ZOOM

  @query('gmp-map')
  googleMap: any

  previousCoordinates: CSMapCoordinates = {
    type: '',
    location: {
      latitude: 52.09,
      longitude: 5.09,
    }
  }

  constructor() {
    super()

    createEffect(() => {
      this.stores = this.storeLocatorStore.stores().stores
      this.coordinates = this.storeLocatorStore.mapCoordinates()
      this.config = this.mapConfigStore.mapZoomConfig()
      // tomfoolery to prevent errors if you pass it null
      if (this.coordinates) {
        this.previousCoordinates = this.coordinates

        this.googleMap?.setAttribute('zoom', this.config[this.coordinates.type])
      }
    })
  }

  calculateCenterString = () => {
    if (this.coordinates) {
      return `${this.coordinates.location.latitude},${this.coordinates.location.longitude}`
    } else {
      return `${this.previousCoordinates.location.latitude},${this.previousCoordinates.location.longitude}`
    }
  }

  calculateStoreMarkerPositionString = (store: InternalStore) => {
    return `${store.address.geoLocation.latitude},${store.address.geoLocation.longitude}`
  }

  markerClicked = (store: InternalStore) => {
    this.storeLocatorStore.selectStore(store)
  }

  isCustomMarkerProvided() {
    return this.mapConfigStore.marker
  }

  override render() {
    return html`
      <gmp-map
        class="csc-store-map"
        center="${this.calculateCenterString()}"
        map-id="CS_STORE_LOCATOR_MAP"
      >
        ${this.stores.map(store => this.isCustomMarkerProvided() ? html`
          <gmp-advanced-marker
            position="${this.calculateStoreMarkerPositionString(store)}"
            title="${store.name}"
            gmp-clickable
            @click="${() => this.markerClicked(store)}"
          >
            ${unsafeHTML(this.mapConfigStore.marker)}
          </gmp-advanced-marker>
        ` : html`
          <gmp-advanced-marker
            position="${this.calculateStoreMarkerPositionString(store)}"
            title="${store.name}"
            gmp-clickable
            @click="${() => this.markerClicked(store)}"
          ></gmp-advanced-marker>
        `)}
      </gmp-map>
    `
  }

  override firstUpdated() {
    this.googleMap.setAttribute('zoom', this.config.initial)
  }
}
